import { initializeControls } from '@atlassian/browser-storage-controls/cookie-controls';
import { fg } from '@atlassian/jira-feature-gating';
import { isFedRamp } from '@atlassian/atl-context';
import { autoBeforeEachTest } from '@atlassian/jira-platform-auto-before-each-test/src/auto-before-each-test.tsx';

let initializeControlsPromise: Promise<void> | null = null;

export function initControlsOnce(): Promise<void> {
	if (!initializeControlsPromise) {
		if (fg('fedramp-cookies-controls')) {
			initializeControlsPromise = initializeControls({
				product: 'Jira',
				webStorageEnabled: fg('jfp-vulcan-browser-storage-migration'),
				perimeter: isFedRamp() ? 'fedramp-moderate' : 'commercial',
			});
		} else {
			initializeControlsPromise = initializeControls({
				product: 'Jira',
				webStorageEnabled: fg('jfp-vulcan-browser-storage-migration'),
			});
		}
	}
	return initializeControlsPromise;
}

autoBeforeEachTest(() => {
	initializeControlsPromise = null;
});
